export type ContentCategoryType = 'includes' | 'excludes' | 'INCLUDES' | 'EXCLUDES'

export interface DetailTranslation {
  language: string
  title: string
  description?: string
}

export interface ContentCategoryDetail {
  title: string
  description?: string
  translations?: DetailTranslation[]
}

export const normalizeContentCategoryType = (type: string): 'includes' | 'excludes' | null => {
  const normalized = type?.toLowerCase()
  if (normalized === 'includes' || normalized === 'excludes') {
    return normalized
  }
  return null
}

export const isContentCategoryType = (
  itemType: string,
  expected: 'includes' | 'excludes',
): boolean => normalizeContentCategoryType(itemType) === expected

export const localizeDetails = (
  details: ContentCategoryDetail[] | undefined,
  language: string,
): ContentCategoryDetail[] =>
  (details || []).map((detail) => {
    const translation = detail.translations?.find((t) => t.language === language)
    return {
      ...detail,
      title: translation?.title ?? detail.title,
      description: translation?.description ?? detail.description ?? '',
      translations: detail.translations || [],
    }
  })

export const buildDetailPayload = (
  item: { title: string; description: string },
  index: number,
  existingDetails: ContentCategoryDetail[] | undefined,
  selectedLanguage: string,
): {
  title: string
  description: string
  translations: Array<{ language: string; title: string; description: string }>
} => {
  const existingItem = existingDetails?.[index]
  const baseTitle = existingItem?.title ?? item.title
  const baseDescription = existingItem?.description ?? item.description ?? ''
  const existingTranslations = existingItem?.translations || []

  const translations = [
    ...existingTranslations
      .filter((t) => t.language !== selectedLanguage)
      .map((t) => ({
        language: t.language,
        title: t.title,
        description: t.description ?? '',
      })),
    {
      language: selectedLanguage,
      title: item.title,
      description: item.description,
    },
  ]

  return {
    title: baseTitle,
    description: baseDescription,
    translations,
  }
}
